import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';
// eslint-disable-next-line import/no-cycle
import BillingSummaryModal from './billing-summary-modal';
import {
  ApplyCouponCodeRequest,
  ModifySubscriptionRequest,
  Plan,
  PurchaseModifySubscriptionRequest,
  PurchaseSubscriptionRequest,
} from '../../../../types';
import {
  applyCouponCodeRequest,
  modifySubscriptionRequest,
  purchaseModifySubscriptionRequest,
  purchaseSubscriptionRequest,
} from '../../../../extra-actions';
import {
  deleteAppliedCouponCode,
  resetHandleSubscriptionResponse,
  resetSubscription,
} from '../../../../billing-subscription-slice';
import { getAdminSettingsRequest } from '../../../../../admin-settings/extra-actions';

const mapStateToProps = (state: RootState) => ({
  getAdminSettingsRequestStatus:
    state.adminSettings.getAdminSettingsRequest.status,
  getAdminSettingsRequestMessage:
    state.adminSettings.getAdminSettingsRequest.message,
  getAdminSettingsRequestError:
    state.adminSettings.getAdminSettingsRequest.error,

  sendPurchaseSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseSubscriptionRequest.status,
  sendPurchaseSubscriptionRequestError:
    state.billingAndSubscription.purchaseSubscriptionRequest.error,
  sendPurchaseSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseSubscriptionRequest.message,

  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,

  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  isSendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error?.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,

  sendGetModifySubscriptionRequestStatus:
    state.billingAndSubscription.modifySubscriptionRequest.status,
  sendGetModifySubscriptionRequestError:
    state.billingAndSubscription.modifySubscriptionRequest.error,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  sendGetPurchaseModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseModifySubscriptionRequest.status,

  sendGetHandleSubscriptionResponse:
    state.billingAndSubscription.handleSubscriptionResponse,
  sendGetHandleSubscriptionRequestError:
    state.billingAndSubscription.handleSubscriptionRequest.error,
  sendGetHandleSubscriptionRequestStatus:
    state.billingAndSubscription.handleSubscriptionRequest.status,

  sendGetCalculatePayRequestStatus:
    state.billingAndSubscription.calculatePayRequest.status,
  sendGetCalculatePayResponse:
    state.billingAndSubscription.getCalculatePayResponse,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  currentPlanName: state.home?.subscription?.planName,
  currentPlanCode: state.home?.subscription?.planCode,
  hasAccountSubscription: state.home?.subscription?.customerId,
  isValidUser: state.home?.signup_date,
  adminSettings: state.adminSettings?.adminSettings,
});

const mapDispatchToProps = {
  sendGetAdminDetailsRequest: () => getAdminSettingsRequest(),
  sendPurchaseSubscriptionRequest: (payload: PurchaseSubscriptionRequest) =>
    purchaseSubscriptionRequest(payload),
  resetSubscription: () => resetSubscription(),
  resetHandleSubscriptionResponse: () => resetHandleSubscriptionResponse(),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendModifySubscriptionRequest: (payload: ModifySubscriptionRequest) =>
    modifySubscriptionRequest(payload),
  sendPurchaseModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseModifySubscriptionRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onClose: VoidFunction;
  selectedPlanDetails: Plan | null;
  isUserModifyingSubscription: boolean;
  onPurchase: (token: string, couponCode: string) => void;
  isAnnuallyCycle: boolean;
  dynamicAmount?: number | null;
  setDynamicAmount?: (amount: number | null) => void;
  preAppliedCouponCode?: string;
};

export default connector(BillingSummaryModal);
